import Vue from "vue";
import {postBlob} from "../plugins/axios";
import {parseTime} from "../utils";

export function liveGuaranteeBatchCreate(data) {
  return Vue.axios({
    url: '/api/live_guarantee/batch_create',
    method: 'post',
    data
  })
}

/**
 * 认领
 * @param data
 * @returns {*}
 */
export function liveGuaranteeClaim(data) {
  return Vue.axios({
    url: '/api/live_guarantee/claim',
    method: 'post',
    data
  })
}

export function liveGuaranteeByRebate(data) {
  return Vue.axios({
    url: '/api/live_guarantee/claim_by_rebate',
    method: 'post',
    data
  })
}
export function liveGuaranteeImportValidate(data) {
  return Vue.axios({
    url: '/api/live_guarantee/import_validate',
    method: 'post',
    data
  })
}

/**
 * 确认
 * @param data
 * @returns {*}
 */
export function liveGuaranteeConfirm(data) {
  return Vue.axios({
    url: '/api/live_guarantee/confirm',
    method: 'post',
    data
  })
}

export function liveGuaranteeDelete(data) {
  return Vue.axios({
    url: '/api/live_guarantee/delete',
    method: 'post',
    data
  })
}

export function liveGuaranteeUndoImport(data) {
  return Vue.axios({
    url: '/api/live_guarantee/undo_import',
    method: 'post',
    data
  })
}

/**
 * 取消确认
 * @param data
 * @returns {*}
 */
export function liveGuaranteeUnConfirm(data) {
  return Vue.axios({
    url: '/api/live_guarantee/un_confirm',
    method: 'post',
    data
  })
}

/**
 * 撤销
 * @param data
 * @returns {*}
 */
export function liveGuaranteeCancel(data) {
  return Vue.axios({
    url: '/api/live_guarantee/cancel',
    method: 'post',
    data
  })
}

/**
 * 列表
 * @param params
 * @returns {*}
 */
export async function liveGuaranteeList(params) {
  const response = await Vue.axios({
    url: '/api/live_guarantee/list',
    method: 'get',
    params
  })

  const table = response && response.model && response.model.data ? response.model.data : []
  table.map(row => {
    row._date_live = row.date_live ? parseTime(row.date_live, '{y}年{m}月') : ''
    row._date_check = row.date_check ? parseTime(row.date_check, '{y}年{m}月') : ''
  })
  response.model.data = table
  return response
}

export function liveGuaranteeListStat(params) {
  return Vue.axios({
    url: '/api/live_guarantee/list_stat',
    method: 'get',
    params
  })
}

/**
 * 指定订单直播记录
 * @param params
 * @returns {*}
 */
export function liveGuaranteeTheOrderRecords(params) {
  return Vue.axios({
    url: '/api/live_guarantee/the_order_records',
    method: 'get',
    params
  })
}

/**
 * 指定订单保量/保次进度
 * @param params
 * @returns {*}
 */
export function liveGuaranteeTheOrderSchedule(params) {
  return Vue.axios({
    url: '/api/live_guarantee/the_order_schedule',
    method: 'get',
    params
  })
}

/**
 * 指定订单直播手动添加记录列表
 * @param params
 * @returns {*}
 */
export function liveGuaranteeTheOrderRecordManually(params) {
  return Vue.axios({
    url: '/api/live_guarantee/the_order_record_manually',
    method: 'get',
    params
  })
}

/**
 * 查询全案营销主单
 * @param params
 * @returns {*}
 */
export function liveGuaranteeQueryWmc(params) {
  return Vue.axios({
    url: '/api/live_guarantee/query_wmc',
    method: 'get',
    params
  })
}

/**
 * 取消认领
 * @param data
 * @returns {*}
 */
export function liveGuaranteeUnClaim(data) {
  return Vue.axios({
    url: '/api/live_guarantee/un_claim',
    method: 'post',
    data
  })
}
//撤回认领-佣金
export function liveGuaranteeUnByRebate(data) {
  return Vue.axios({
    url: '/api/live_guarantee/un_claim_by_rebate',
    method: 'post',
    data
  })
}
/**
 * 导出汇总
 * @param data
 * @returns {*}
 */
export function liveGuaranteeExportStat(data) {
  return postBlob('/api/live_guarantee/export_stat', data)
}

/**
 * 直播记录-手动增加
 * @param data
 * @returns {*}
 */
export function liveGuaranteeRecordAdd(data) {
  return Vue.axios({
    url: '/api/live_guarantee/record_add',
    method: 'post',
    data
  })
}

/**
 * 直播记录-删除手动增加记录
 * @param id
 * @returns {*}
 */
export function liveGuaranteeManuallyAddByDelete(id) {
  return Vue.axios({
    url: '/api/live_guarantee/manually_add_by_delete',
    method: 'post',
    data: { id: id }
  })
}

/**
 * 直播记录-手动增加
 * @param data
 * @returns {*}
 */
export function liveGuaranteeRecordUpd(data) {
  return Vue.axios({
    url: '/api/live_guarantee/record_upd',
    method: 'post',
    data
  })
}
